// extracted by mini-css-extract-plugin
export var container = "section-tiles-module--container--4S7tC";
export var desc = "section-tiles-module--desc--P-Mfg";
export var grid = "section-tiles-module--grid--Id2Qq";
export var image = "section-tiles-module--image--KZCEL";
export var imageContainer = "section-tiles-module--image-container--JWraR";
export var tileContainer = "section-tiles-module--tile-container--94ifa";
export var tileTitle = "section-tiles-module--tile-title--hz5-Z";
export var title = "section-tiles-module--title--BbxQp";